import { ApplicationDetailsDto } from '../../legacy/shared-types';
import { API } from '../../providers/ApiInterceptorProvider';
import { ApplicationForListingDto } from 'pages/ApplicationsListingPage/ApplicationsTable/types';

export const applicationsApi = {
  getByReferenceNumber: async (referenceNumber: string): Promise<ApplicationDetailsDto> => {
    try {
      const { data } = await API.get<ApplicationDetailsDto>(`/application/${referenceNumber}`);

      return data;
    } catch (err: any) {
      throw new Error(err.response.data.message);
    }
  },
  getAll: async () => {
    try {
      const { data } = await API.get<Record<string, string>>(`/application/broker`);

      return data;
    } catch (err: any) {
      throw new Error(err.response.data.message);
    }
  },
  getAnalystAll: async () => {
    try {
      const { data } = await API.get<ApplicationForListingDto[]>(`/application/brokers/list`);

      const dataArray = Array.isArray(data) ? data : [];
      return dataArray;
    } catch (err: any) {
      throw new Error(err.response.data.message);
    }
  },
};
